import { cookieManager } from "./cookies.js";
import { z } from "zod";

//#region ../base/auth/from-admin.ts
const zAuthFromAdminMetadata = z.object({
	readOnly: z.boolean(),
	username: z.string(),
	date: z.string()
});
/**
* Verify that the auth from admin payload has the correct properties
*/
function isAuthFromAdminMetadata(data) {
	return Boolean(data && typeof data === "object" && "readOnly" in data && typeof data.readOnly === "boolean" && "username" in data && typeof data.username === "string" && data.username && "date" in data && typeof data.date === "string" && data.date);
}
function isAuthFromAdminPayload(data) {
	return isAuthFromAdminMetadata(data) && "authToken" in data && typeof data.authToken === "string";
}
function decodePayload(str) {
	const payload = JSON.parse(atob(str));
	if (!isAuthFromAdminPayload(payload)) throw new Error("Invalid payload");
	return payload;
}
function getAuthFromAdminPayloadFromUrl(queryParam) {
	if (typeof window === "undefined") return;
	const usp = new URLSearchParams(window.location.search);
	const value = usp.get(queryParam);
	if (!value) return;
	try {
		return decodePayload(value);
	} catch (err) {
		console.warn("Login through admin failed. Invalid payload.");
	}
}
/**
* Check if current session was established in the admin dashboard and get metadata.
*/
function getAuthFromAdminMetadataFromCookie(cookieName) {
	const value = cookieManager.getCookie(cookieName);
	if (!value) return;
	try {
		const meta = JSON.parse(value);
		if (isAuthFromAdminMetadata(meta)) return meta;
	} catch (err) {}
}

//#endregion
export { getAuthFromAdminMetadataFromCookie, getAuthFromAdminPayloadFromUrl, zAuthFromAdminMetadata };
//# sourceMappingURL=from-admin.js.map